import { ChangeEvent, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useAuthenticationDataContext } from '../../Helpers/AuthenticationDataProvider';

import { useAuthorizationDataContext } from '../../Helpers/AuthorizationDataProvider';
import useFetchWrapper, { HttpResponse } from '../../Helpers/useFetchWrapper';
import { WebSocketService } from '../../Helpers/WebSocketProvider';


import { HookProps, Meeting } from './Media.model';

const useMedia = ({ isInitiator, initialMeetUrl }: HookProps) => {
	const [ jwt, setJwtData ] = useState<string | null>(null);
	const [ meetUrl, setMeetUrl ] = useState<string>(initialMeetUrl);
	const [ onCall, setOnCall ] = useState<boolean>(true);
	const [ roomName, setRoomName ] = useState<string>('');
	const [loading, setLoading] = useState<boolean>(true);
	const [organizer, setOrganizer] = useState<string>();
	const [showPopup, setShowPopup] = useState(false);
	const [hasRecordings, setHasRecordings] = useState(false);
	const [isDirectCall, setIsDirectCall] = useState(false);

	const { role } = useAuthorizationDataContext();

	const { userId } = useAuthenticationDataContext();
	
	const { get, post } = useFetchWrapper();

	const { closeWS, initializeWS, onUserEnteredCall, onUserLeftCall } = WebSocketService();
	
	const history = useHistory();

  useEffect(() => {
		meetUrl && extractUrlDetails(meetUrl);
	}, [meetUrl]);

	useEffect(() => {
		if (isDirectCall) {
			setTimeout(() => { initializeWS(roomName, userId, onUserEnteredCall) }, 10);
		} 
	}, [isDirectCall]);
	
	useEffect(() => {
		return () => {closeWS(userId, roomName, onUserLeftCall)};
	},[])

	const onChangeMeetUrl = (event: ChangeEvent<HTMLInputElement>) => {
		const el: HTMLInputElement = event.currentTarget;
		setMeetUrl(el.value);
	}

	const onClickJoinMeeting = async () => {
		setOnCall(true);
	}

	const getJwt = async (eventId: string) => {
		const response = await get<string>(`/calendar/scheduled-call/${eventId}`);

		if (response.parsedBody) {
			const jwt = decodeURIComponent(response.parsedBody).match(`[?&]jwt=([^&]+).*$`);
			if (jwt) setJwtData(jwt[1]);
		}
	}

	const getOrganizer = async (eventId: string) => {
		try {
				const response: HttpResponse<Meeting> = await get(`/calendar/events/${eventId}`);
			if (response.parsedBody) setOrganizer(response.parsedBody.organizer.userId);
			else {
					const response = await get<string>(`/calendar/direct-call/${eventId}`);
				if (response.parsedBody) {
					setIsDirectCall(true);
				}
			}
		} catch(error) {
			console.log(error);
		}
	}

	const extractUrlDetails = (url: string) => {
		const decodedUrl = decodeURIComponent(url);
		const matchedJwt = decodedUrl.match(`[?&]jwt=([^&]+).*$`);
		const roomName = decodedUrl.slice(decodedUrl.lastIndexOf('/') + 1, matchedJwt ? url.lastIndexOf('?'): url.length);

		setRoomName(roomName);

		getOrganizer(roomName);

		if (matchedJwt) {
			setJwtData(matchedJwt[1]);
		} else {
			getJwt(roomName)
		};
	}

	const isOrganizer = () => {
		return organizer === userId || isDirectCall;
	}

	const onMeetingEnd = async () => {
		setOnCall(false);
		setShowPopup(true);
		roomName && closeWS(userId, roomName, onUserLeftCall);
	}

	const onMeetingStart = async ({ participants, name, recording }: { [key: string]: any }) => {
		setLoading(false);
		//await post(`/rocket/meeting`, { name, participants, recording });
	}
	
  const onRecordingStatusChange = async ({ status }: { [key: string]: any }) => {
		if(role === 'Mentor') {
			if (status) {
				setHasRecordings(true);
				await post(`/meeting/record/${roomName}`, {});
			}
		} else return;
  }

  const onParticipantsNrChange = async ({ participants, recording }: {[key: string]: any}) => {
		//await put(`/rocket/meeting/${roomName}`, { participants, recording });
	}
	
	const togglePopup = () => {
		setShowPopup((currentValue) => !currentValue);
	}
	const navigate = (values: { pathname: string, state: { [key: string]: any } }) => {
		history.push(values);
	}

	return {
		isOrganizer,
		navigate,
    onChangeMeetUrl,
    onClickJoinMeeting,
    onMeetingEnd,
    onMeetingStart,
    onParticipantsNrChange,
    onRecordingStatusChange,
    role,
		state: {
			hasRecordings,
			jwt,
			loading,
      meetUrl,
			onCall,
			organizer,
			roomName,
			showPopup
		},
		togglePopup
  }
}

export default useMedia;

